module.exports = __webpack_public_path__ + "static/media/top-bar-timer-clock-icon.37a34085.svg";